export default __webpack_public_path__ + "static/media/forest1.ebcc7031.jpg";